$(window).on("load", function () {
    $(".counter").countUp();

    // If visitor arrives directly on a homepage, use the server-provided current key first.
    // Otherwise fall back to the cookie.
    applySelectedFlagFromCurrentHomePageKeyOrCookie();
});

function toggleDropdown() {
    const dropdown = document.getElementById("flagDropdown");
    if (!dropdown) return;

    dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
}

// ─────────────────────────────────────────────────────────────
// Cookie helpers (persist selection across page loads)
// ─────────────────────────────────────────────────────────────
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
}

function getCookie(name) {
    var nameEq = name + "=";
    var parts = document.cookie.split(";");
    for (var i = 0; i < parts.length; i++) {
        var c = parts[i].trim();
        if (c.indexOf(nameEq) === 0) {
            return decodeURIComponent(c.substring(nameEq.length));
        }
    }
    return null;
}

// ─────────────────────────────────────────────────────────────
// Rendering helpers
// ─────────────────────────────────────────────────────────────
function setSelectedFlagUI(flagTitle, flagImage) {
    var img = document.getElementById("selected-flag");
    var txt = document.getElementById("selected-text");

    if (img && flagImage) img.src = flagImage;
    if (txt && flagTitle) txt.textContent = flagTitle;
}

// IMPORTANT:
// Add this hidden input in your Razor where you have currentHomePageKey:
// <input type="hidden" id="currentHomePageKey" value="@currentHomePageKey" />
function getCurrentHomePageKeyFromDom() {
    var el = document.getElementById("currentHomePageKey");
    if (!el) return null;

    var val = (el.value || "").trim();
    return val.length ? val : null;
}

function applySelectedFlagFromCurrentHomePageKeyOrCookie() {
    // 1) Prefer current homepage key (direct visit)
    var currentKey = getCurrentHomePageKeyFromDom();
    if (currentKey) {
        var mapped = mapFlagBySiteKey(currentKey);
        if (mapped) {
            setSelectedFlagUI(mapped.title, mapped.image);

            // keep cookie in sync with the page they actually landed on
            setCookie("selectedSiteKey", currentKey, 365);
            setCookie("selectedFlagTitle", mapped.title, 365);
            setCookie("selectedFlagImage", mapped.image, 365);

            return;
        }
    }

    // 2) Fall back to cookie
    var flagTitle = getCookie("selectedFlagTitle");
    var flagImage = getCookie("selectedFlagImage");
    if (flagTitle && flagImage) {
        setSelectedFlagUI(flagTitle, flagImage);
    }
}

// Map your known homepage keys -> flag title/image
function mapFlagBySiteKey(siteKey) {
    if (!siteKey) return null;

    // UK + IRL
    if (siteKey === "aa7eee80-35b3-407a-bfb0-1a5842123d6f") {
        return { title: "UK + IRL", image: "/Frontend/Images/uu1.svg" };
    }

    // US + CAN
    if (siteKey === "3e3e9663-0493-432e-8305-831fded1eb6d") {
        return { title: "US + CAN", image: "/Frontend/Images/uu.svg" };
    }

    return null;
}

// ─────────────────────────────────────────────────────────────
// Flag selection
// ─────────────────────────────────────────────────────────────
function selectFlag(siteKey, siteUrl, flagTitle, flagImage) {
    // Persist selection (365 days)
    if (siteKey) setCookie("selectedSiteKey", siteKey, 365);
    if (flagTitle) setCookie("selectedFlagTitle", flagTitle, 365);
    if (flagImage) setCookie("selectedFlagImage", flagImage, 365);
    if (siteUrl) setCookie("selectedSiteUrl", siteUrl, 365);

    // Hide dropdown immediately
    var dropdown = document.getElementById("flagDropdown");
    if (dropdown) dropdown.style.display = "none";

    // Redirect
    window.location.href = siteUrl;
}

document.addEventListener("click", function (e) {
    if (!e.target.closest(".flag-select")) {
        var dropdown = document.getElementById("flagDropdown");
        if (dropdown) dropdown.style.display = "none";
    }
});
